import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#8B1E1E",
        secondary: "#6E1414",
        accent: "#C62828",
        error: "#b71c1c",
      },
    },
  },
});
